import React from "react";
import Radio from "../../../../../shared/Radio/Radio";

const PeriodTypeRadioSelector = props => {
	const handleChange = event => {
		props.onChange({ periodType: event.value });
	};

	return (
		<div>
			<Radio
				onChange={event => handleChange(event)}
				horizontally={true}
				name="date-method"
				options={[
					{
						label: "Data de venda",
						value: 0,
						checked: props.type === 0
					},
					{
						label: "Data de pagamento",
						value: 1,
						checked: props.type === 1
					}
				]}
				data-action="period-type-radio-selector-date-method-radio"
			/>
		</div>
	);
};

export default PeriodTypeRadioSelector;
